import { render, staticRenderFns } from "./FormPacking.vue?vue&type=template&id=3a01e317&scoped=true&"
import script from "./FormPacking.vue?vue&type=script&lang=js&"
export * from "./FormPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01e317",
  null
  
)

export default component.exports